import { AlertTriangle, CalendarClock } from 'lucide-react';
import type { GoalPriority, GoalStatus, GoalTargetType } from '@pms/shared';
import { cn } from '@/lib/utils';
import {
  GOAL_PRIORITY_META,
  GOAL_STATUS_META,
  GOAL_TARGET_TYPE_META,
} from './goalConstants';

const PILL = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold leading-none whitespace-nowrap';

export function GoalStatusBadge({ status, className }: { status: GoalStatus; className?: string }) {
  const meta = GOAL_STATUS_META[status];
  return <span className={cn(PILL, meta.className, className)} title={meta.description}>{meta.label}</span>;
}

export function GoalTargetTypeBadge({ type, className }: { type: GoalTargetType; className?: string }) {
  const meta = GOAL_TARGET_TYPE_META[type];
  return <span className={cn(PILL, meta.className, className)} title={meta.hint}>{meta.label}</span>;
}

export function GoalPriorityBadge({ priority, className }: { priority: GoalPriority; className?: string }) {
  const meta = GOAL_PRIORITY_META[priority];
  return <span className={cn(PILL, meta.className, className)}>{meta.label}</span>;
}

/** Only rendered when a goal actually needs attention, so it always means something. */
export function GoalRiskBadge({
  isOverdue,
  isAtRisk,
  className,
}: {
  isOverdue: boolean;
  isAtRisk: boolean;
  className?: string;
}) {
  if (isOverdue) {
    return (
      <span className={cn(PILL, 'bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-400', className)}>
        <AlertTriangle className="h-3 w-3" /> Overdue
      </span>
    );
  }
  if (isAtRisk) {
    return (
      <span className={cn(PILL, 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400', className)}>
        <CalendarClock className="h-3 w-3" /> At risk
      </span>
    );
  }
  return null;
}
